/**
 * Shorten a TON address (or any long string) for display.
 * Returns `fallback` when value is empty / null / undefined.
 * Does NOT shorten strings shorter than start + end + 3 chars.
 *
 * @example
 * shortenAddress("kQBT...NGi1f")          // "kQBT…NGi1f"
 * shortenAddress("kQBT...NGi1f", 4, 4)    // "kQBT…i1f"
 * shortenAddress(null)                     // "—"
 */
export function shortenAddress(
  value: string | null | undefined,
  start = 6,
  end = 5,
  fallback = "—"
): string {
  if (!value) return fallback;
  if (value.length <= start + end + 3) return value;
  return `${value.slice(0, start)}…${value.slice(-end)}`;
}
